function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var DebugLevels = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3
};
var currentDebugLevel = DebugLevels.DEBUG;
/**
 * LogClient implementation that allows logging to multiple places by delegating to other clients.
 * A practical use case is logging to both console and server in development regions.
 **/

var CompositeLogClient = function CompositeLogClient() {
  var _this = this;

  _classCallCheck(this, CompositeLogClient);

  _defineProperty(this, "debug", function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this.clients.forEach(function (client) {
      return client.debug.apply(client, args);
    });
  });

  _defineProperty(this, "info", function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this.clients.forEach(function (client) {
      return client.info.apply(client, args);
    });
  });

  _defineProperty(this, "warn", function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this.clients.forEach(function (client) {
      return client.warn.apply(client, args);
    });
  });

  _defineProperty(this, "error", function () {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this.clients.forEach(function (client) {
      return client.error.apply(client, args);
    });
  });

  for (var _len = arguments.length, clients = new Array(_len), _key = 0; _key < _len; _key++) {
    clients[_key] = arguments[_key];
  }

  this.clients = clients;
};
/** Simple Log Client that only writes to window.console **/

var ConsoleLogClient = function ConsoleLogClient() {
  _classCallCheck(this, ConsoleLogClient);

  _defineProperty(this, "debug", function () {
    var _window$console;

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    var marker = args[0],
        rest = args.slice(1);

    (_window$console = window.console).log.apply(_window$console, ["[".concat(marker, "]: ")].concat(_toConsumableArray(rest)));
  });

  _defineProperty(this, "info", function () {
    var _window$console2;

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    var marker = args[0],
        rest = args.slice(1);

    (_window$console2 = window.console).info.apply(_window$console2, ["[".concat(marker, "]: ")].concat(_toConsumableArray(rest)));
  });

  _defineProperty(this, "warn", function () {
    var _window$console3;

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    var marker = args[0],
        rest = args.slice(1);

    (_window$console3 = window.console).warn.apply(_window$console3, ["[".concat(marker, "]: ")].concat(_toConsumableArray(rest)));
  });

  _defineProperty(this, "error", function () {
    var _window$console4;

    for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
      args[_key9] = arguments[_key9];
    }

    var marker = args[0],
        rest = args.slice(1);

    (_window$console4 = window.console).error.apply(_window$console4, ["[".concat(marker, "]: ")].concat(_toConsumableArray(rest)));
  });
};
var currentLogClient = new ConsoleLogClient();
/**
 * Logger class used to add application logging to modules..
 * Typically create a new instance per module / source file as follows
 * const LOG = new Logger('MyModuleName');
 * Then use in the module using LOG.debug/warn/error
 **/

var Logger =
/*#__PURE__*/
function () {
  // TODO: allow setting debug level configuration per known 'prefix'
  // TODO: match log format we use in splunk? (or should backend do this?)
  function Logger(marker) {
    _classCallCheck(this, Logger);

    this.marker = marker;
  }

  _createClass(Logger, [{
    key: "debug",
    value: function debug() {
      if (currentDebugLevel <= DebugLevels.DEBUG) {
        var _currentLogClient;

        for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          args[_key10] = arguments[_key10];
        }

        (_currentLogClient = currentLogClient).debug.apply(_currentLogClient, [this.marker].concat(args));
      }
    }
  }, {
    key: "info",
    value: function info() {
      if (currentDebugLevel <= DebugLevels.INFO) {
        var _currentLogClient2;

        for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          args[_key11] = arguments[_key11];
        }

        (_currentLogClient2 = currentLogClient).info.apply(_currentLogClient2, [this.marker].concat(args));
      }
    }
  }, {
    key: "warn",
    value: function warn() {
      if (currentDebugLevel <= DebugLevels.WARN) {
        var _currentLogClient3;

        for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          args[_key12] = arguments[_key12];
        }

        (_currentLogClient3 = currentLogClient).warn.apply(_currentLogClient3, [this.marker].concat(args));
      }
    }
  }, {
    key: "error",
    value: function error() {
      if (currentDebugLevel <= DebugLevels.ERROR) {
        var _currentLogClient4;

        for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
          args[_key13] = arguments[_key13];
        }

        (_currentLogClient4 = currentLogClient).error.apply(_currentLogClient4, [this.marker].concat(args));
      }
    }
  }]);

  return Logger;
}();
function setDebugLevel(debugLevel) {
  currentDebugLevel = debugLevel;
}
/* Set Global LogClient for all logger instances */

function setLogClient(logClient) {
  currentLogClient = logClient;
}

export default Logger;
export { Logger, DebugLevels, CompositeLogClient, ConsoleLogClient, setDebugLevel, setLogClient };
//# sourceMappingURL=index.js.map
